import lodash from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { financeResellerAllSelector } from "store/bailiff/finance/reseller/finance_reseller.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDataFinance = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const finance = useSelector(financeResellerAllSelector);
  const data = lodash.orderBy(finance, "setAt", "desc") || [];

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};
